<template>
  <div>
    <nut-navbar
      :left-show="false"
      :title="$t('taskReward.h1')"
      fixed=true
      class="mb0 nav-icon-right nut-navbar--fixed"
    >
    </nut-navbar>
    <div class="signin-task" v-if="dailyGrowthList.length > 0">
      <img :src="require('../assets/images/' + imgUrl + 'bg20.jpg')" />
      <div class="bd">
        <div class="dayls">
          <div class="d"  
            :class="{
              'complete': item.day < dailyGrowthCurrent.day,
              'active': item.day === dailyGrowthCurrent.day,
            }"
            v-for="(item, index) in dailyGrowthList" :key="index" :title="item.title" :conditionType="item.conditionType">
            <h5>{{$t('taskReward.day')}} {{item.day}}</h5>
            <p v-show="item.day <= dailyGrowthCurrent.day">{{ $filters.currencySymbol(item.rewardAmount) }}</p>
            <p v-show="item.day > dailyGrowthCurrent.day">?</p>
          </div>
        </div>
        <div class="btn">
          <nut-button v-if="dailyGrowthCurrent.status==='locked'" block type="warning" @click="dailyGrowthClick" disabled>{{$t('taskReward.dailyQuestLocked')}}</nut-button>
          <nut-button v-if="dailyGrowthCurrent.status==='processing'" block type="warning" @click="dailyGrowthClick">{{$t('taskReward.dailyQuest')}}</nut-button>
          <nut-button v-if="dailyGrowthCurrent.status==='wait_receive'" block type="warning" @click="dailyGrowthClick">{{$t('taskReward.dailyQuestCompleted')}}</nut-button>
          <nut-button v-if="dailyGrowthCurrent.status==='received'" block type="warning" @click="dailyGrowthClick">{{$t('taskReward.dailyQuestFinished')}}</nut-button>
          
          <div class="tg-btn" v-if="country === 'in' && template === 's1'" @click="toTelegram" style="margin: 5px 0 -20px 0;">
            <img src="../assets/images/bg312.png" style="height: 34px !important;" />
          </div>
          <div class="tg-btn" v-else-if="country === 'br' && template === 's1'" @click="toTelegram" style="margin: 5px 0 -20px 0;">
            <img src="../assets/images/bg313.png"  />
          </div>


        </div>
      </div>
    </div>
    <div v-else style="height:80px"></div>

    <nut-popup
      pop-class="popclass pop-signin"
      v-model:visible="showBasic"
      :z-index="100">
      <div class="pop-t">
        <h4><span>{{$t('taskReward.day')}} {{currentDay}}</span></h4>
        <h4>{{ title }}</h4>
        <!--h4 style="color: #722400;font-size: 14px;">{{ conditionText }}</!--h4 -->
        <p>
          <strong>{{ $filters.currencySymbol(rewardAmount) }}</strong>
        </p>
      </div>
      <div class="pop-b">
        <span style="font-size:12px;display: block;">{{dailyGrowthCurrent.progress}}% {{$t('taskReward.complete')}}</span>
        <nut-button v-if="dailyGrowthCurrent.status === 'processing'" block type="warning" @click="goToTaskUrl(conditionType)">{{$t('taskReward.completeTask')}}</nut-button>
        <nut-button v-if="dailyGrowthCurrent.status === 'wait_receive'" block type="warning" @click="receiveAward(rewardAmount)">{{$t('taskReward.receiveReward')}}</nut-button>
        <nut-button v-if="dailyGrowthCurrent.status === 'received'" block type="info"  disabled=ture>{{$t('taskReward.received')}}</nut-button>
      </div>
    </nut-popup>

    <!-- 新手签到 -->
    <div class="task-list" v-if="dailySignList.length > 0 &&  dailySignCurrent.type === 'rookie'">
      <div class="task-item">
        <div class="task-flex">
          <div class="l type-1">
            <h5>{{$t('taskReward.checkIn7Text')}}({{dailySignCurrent.toSignDay}}/7)</h5>
            <p>{{$t('taskReward.vipCheckInText')}}</p>
          </div>
          <div class="r">
            <strong>+{{ $filters.currencySymbol(baseRewardAmount) }}</strong>
          </div>
        </div>
        <nut-row class="b2">
          <nut-col :span="16" class="l">
            <nut-indicator
              :block="true" 
              align="left"
              :size="7"
              :current="dailySignCurrent.toSignDay"
              :fill-zero="false"
              >step1</nut-indicator
            >
          </nut-col>
          <nut-col :span="8" class="r">
            <nut-button size="small" v-show="dailySignCurrent.canSign" type="primary" @click="taskSignClick(baseRewardAmount, extraRewardAmount)">{{$t('taskReward.checkIn')}}</nut-button>
            <nut-button size="small" v-show="!dailySignCurrent.canSign" type="primary" disabled>{{$t('taskReward.checkInLocked')}}</nut-button>
          </nut-col>
        </nut-row>
      </div>
    </div>

    <!-- 非新手签到 -->
    <div class="task-list" v-else-if="dailySignList.length > 0 && dailySignCurrent.type !== 'rookie'">
      <div class="task-item">
        <div class="task-flex">
          <div class="l type-1">
            <h5>{{$t('taskReward.checkInText')}}</h5>
            <p>{{$t('taskReward.vipCheckInText')}}</p>
          </div>
          <div class="r" v-show="baseRewardAmount > 0">
            <strong>+{{ $filters.currencySymbol(baseRewardAmount) }}</strong>
          </div>
        </div>
        <nut-row class="b2">
          <nut-col :span="8" class="r">
            <nut-button size="small" v-show="dailySignCurrent.canSign" type="primary" @click="taskSignClick(baseRewardAmount, extraRewardAmount)">{{$t('taskReward.complete')}}</nut-button>
            <nut-button size="small" v-show="!dailySignCurrent.canSign" type="primary" disabled>{{$t('taskReward.checkInLocked')}}</nut-button>
          </nut-col>
        </nut-row>
      </div>
    </div>

    <div class="d-app" v-show="appTaskStatus === 'forbid' || appTaskStatus === 'can_receive'">
      <h4>
        {{$t('global.DOWNLOAD_APP')}}
        <strong>+{{ $filters.currencySymbol(appTaskReward) }}</strong>
      </h4>
      <p>{{$t('global.DOWNLOAD_APP_TEXT')}}</p>
      <div class="btnbox">
        <nut-button
          size="small"
          v-show="appTaskStatus === 'forbid'"
          type="info"
          @click="downloadApp"
          plain
          >{{$t('global.DOWNLOAD_APP_BTN')}}</nut-button>
        <nut-button
          size="small"
          v-show="appTaskStatus === 'can_receive'"
          @click="downloadReceiveReward(appTaskReward)"
          type="primary"
          >{{$t('taskReward.receiveReward')}}</nut-button>
      </div>
      <div class="b" v-show="appTaskStatus === 'forbid'">{{$t('global.DOWNLOAD_APP_TEXT4')}}</div>
    </div>

    <h4 class="ls-h4">{{$t('taskReward.missionTarget')}}</h4>

    <div class="task-list pb90">
      
      <div
        class="task-item"
        v-for="(item, index) in regularTaskList"
        :key="index"
        :taskType="item.taskType"
        :conditionValue="item.conditionValue"
      >
        <div class="task-flex">
          <div
            class="l"
            :class="{
              //'type-1': item.conditionType === '',
              'type-2':
                item.conditionType === 'first_bet' ||
                item.conditionType === 'bet_times',
              //'type-3': item.conditionType === '',
              'type-4':
                item.conditionType === 'first_effective_invite' ||
                item.conditionType === 'effective_invite_count' ||
                item.conditionType === 'first_invite' ||
                item.conditionType === 'invite_count',
              'type-5': item.conditionType === 'recharge_amount',
              'type-6':
                item.conditionType === 'first_recharge' ||
                item.conditionType === 'recharge_times' ||
                item.conditionType === 'first_withdraw',
              'type-7':
                item.conditionType === 'bet_amount' ||
                item.conditionType === 'first_win' ||
                item.conditionType === 'win_times' ||
                item.conditionType === 'win_amount',
            }"
          >
            <h5>{{ item.taskTitle }}</h5>
            <p>{{ item.entryTitle }}</p>
          </div>
          <div class="r">
            <strong>+{{ $filters.currencySymbol(item.rewardAmount) }}</strong>
            <nut-button
              size="small"
              v-show="item.status === 'processing'"
              type="info"
              @click="goToTaskUrl(item.conditionType)"
              plain
              >{{$t('taskReward.toTask')}}</nut-button
            >
            <nut-button
              size="small"
              v-show="item.status === 'wait_receive'"
              type="primary"
              @click="
                taskReceive(item.serialNum, item.taskId, item.rewardAmount)
              "
              >{{$t('taskReward.receiveReward')}}</nut-button
            >
            <nut-button
              size="small"
              v-show="item.status === 'received'"
              type="primary"
              disabled
              >{{$t('taskReward.received')}}</nut-button
            >
          </div>
        </div>

        <div class="b">
          <nut-progress
            :percentage="item.progress"
            size="small"
            :stroke-color="bgc"
          />
        </div>
      </div>
    </div>

    
    <nut-popup
      position="top"
      :z-index="100"
      :style="{ height: '160px', background:'#fff'  }"
      @closed="topPopclose" 
      v-model:visible="taskPop"
    >
      <div class="pop-top">
        <h4>{{$t('taskReward.getBn')}}</h4>
        <p>
          <strong></strong><strong>{{ $filters.currencySymbol(taskAmount) }}</strong>
        </p>
      </div>
    </nut-popup>

    <tabbar :activeIndex="tabbarActiveIndex"></tabbar>
  </div>
</template>

<script>
import { reactive, toRefs } from "vue";
import TabbarMain from "../components/TabbarMain.vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { Toast } from "@nutui/nutui";
import { getLastTimeGameName,getCountry } from "@/assets/js/environment";
import { getCommonInfoAttr } from "@/assets/js/commonInfo";

export default {
  data() {
    return {
      country: '',
      commonInfo: '',
      template:'',
      imgUrl:'',
      dailyGrowthList: [], //每日成长任务列表
      dailyGrowthCurrent: [], //每日成长任务信息
      dailySignList: {}, //每日签到任务列表
      dailySignCurrent: [], //每日签到任务信息
      regularTaskList: [], //常规任务列表
      appTaskReward: '', //下载app任务 奖励金额
      appTaskStatus: '', //下载app任务 forbid=不可领取 can_receive=可领取  received=已领取
      baseRewardAmount: '',
      extraRewardAmount: '',
      title: '',
      rewardAmount: '',
      conditionType: '',
      conditionText:'',
      currentDay:''
    };
  },
  components: {
    tabbar: TabbarMain,
  },
  methods: {
    textToast(msg) {
      Toast.loading(msg, {
        id: "loading",
        duration: 0,
        bgColor: "rgba(0, 0, 0, 0.9)",
        cover: true,
      });
    },
    toTelegram(){
      if(this.country === 'in'){
        window.open(this.commonInfo.telegramChannelUrl,"_self");
      }else if(this.country === 'br'){
        window.open(this.commonInfo.telegramChannelUrl,"_self");
      }
    },
    getTaskList() {
      this.textToast(this.$t('global.loading'));
      axios
        .get("/api/task", {})
        .then((response) => {
          this.dailyGrowthList = response.data.data.dailyGrowthList;
          this.dailyGrowthCurrent = response.data.data.dailyGrowthCurrent;
          this.dailySignList = response.data.data.dailySignList;
          this.regularTaskList = response.data.data.regularTaskList;
          if(response.data.data.appTaskReward){
            this.appTaskReward = response.data.data.appTaskReward
            this.appTaskStatus = response.data.data.appTaskStatus
          }
          this.currentDay = this.dailyGrowthCurrent.day

          if(this.dailySignList.length > 0){
            this.dailySignCurrent = response.data.data.dailySignCurrent;
            this.dailySignList = response.data.data.dailySignList;
            let i = this.dailySignCurrent.toSignDay
            this.baseRewardAmount = response.data.data.dailySignList[i].baseRewardAmount
            this.extraRewardAmount = response.data.data.dailySignList[i].extraRewardAmount
          }

          let ii = this.dailyGrowthCurrent.day-1
          this.title =  response.data.data.dailyGrowthList[ii].title
          this.rewardAmount =  response.data.data.dailyGrowthList[ii].rewardAmount
          this.conditionType =  response.data.data.dailyGrowthList[ii].conditionType
          //let text = this.conditionType.replace(/_/g," ")
          //this.conditionText = text.substring(0,1).toUpperCase() + text.substring(1) + ' ' + response.data.data.dailyGrowthList[ii].conditionValue
          switch (this.conditionType) {
            case "daily_recharge_times":
              this.conditionText = 'Daily recharge '+ response.data.data.dailyGrowthList[ii].conditionValue +' times'   //当日充值次数达标 x 次
              break;
            case "daily_recharge_amount":
              this.conditionText = 'Daily recharge amount '+ response.data.data.dailyGrowthList[ii].conditionValue  //当日充值金额达标 x 元
              break;
            case "daily_bet_times":
              this.conditionText = 'Daily game '+ response.data.data.dailyGrowthList[ii].conditionValue +' times' //当日下注次数达标 x 次
              break;
            case "daily_bet_amount":
              this.conditionText = 'Daily input amount'+ response.data.data.dailyGrowthList[ii].conditionValue //当日下注金额达标 x 元
              break;
            case "daily_win_times":
              this.conditionText = 'Daily win '+ response.data.data.dailyGrowthList[ii].conditionValue +' times' //当日赢利次数达标 x 次
              break;
            case "daily_win_amount":
              this.conditionText = 'Daily win amount '+ response.data.data.dailyGrowthList[ii].conditionValue //当日赢利金额达标 x 元
              break;
          }

          Toast.hide("loading");
        })
        .catch(function (error) {
          console.log(error);
          Toast.hide("loading");
      })
    }
  },
  created() {
    this.country = getCountry()
    if(window.localStorage.getItem('commonInfo')){
      this.commonInfo = JSON.parse(window.localStorage.getItem('commonInfo'))
    }else{
      axios.get("/api/system/common", {}).then((response)=> {
        this.commonInfo = response.data.data
      })
    }
    this.template = document.querySelector('body').getAttribute('s')
    this.imgUrl = localStorage.getItem('countryImgUrl')
    this.getTaskList();
  },
  setup() {
    const state = reactive({
      bgc: "#6a316c",
      showBasic: false,
      taskPop: false,
      taskAmount: 0,
      startFlag: false,
      tabbarActiveIndex: 3,
    });
    const router = useRouter();
    const methods = {
      downloadApp(){
        window.open(getCommonInfoAttr('appDownloadUrl'))
      },
      downloadReceiveReward(amount){
        state.taskAmount = amount
        axios
          .post("/api/task/app/receive-reward", {})
          .then((res) => {
            console.log(res);
            state.taskPop = true;
            setTimeout(() => {
              state.startFlag = false;
              state.taskPop = false;
            }, 1500)
          })
          .catch(function (error) {
            console.log(error);
          })
      },

      receiveAward(amount){
        state.taskAmount = amount
        axios
          .post("/api/task/daily-growth/receive-reward", {})
          .then((res) => {
            console.log(res);
            state.taskPop = true;
            setTimeout(() => {
              state.startFlag = false;
              state.taskPop = false;
            }, 1500)
          })
          .catch(function (error) {
            console.log(error);
          })
      },
      goToTaskUrl(type) {
        switch (type) {
          case "first_recharge":
            router.push({ name: "rechargeBalance" }); //首次充值
            break;
          case "recharge_times":
            router.push({ name: "rechargeBalance" }); //充值次数达标
            break;
          case "recharge_amount":
            router.push({ name: "rechargeBalance" }); //充值金额达标
            break;
          case "first_invite":
            router.push({ name: "agentPromotion" }); //首次邀请
            break;
          case "invite_count":
            router.push({ name: "agentPromotion" }); //邀请人数达标
            break;
          case "first_effective_invite":
            router.push({ name: "agentPromotion" }); 
            break;
          case "effective_invite_count":
            router.push({ name: "agentPromotion" });
            break;
          case "first_withdraw":
            router.push({
              path: 'withdrawalBalance',
              query: {
                amountType: 'coin'
              }
            })
            break;
          case "daily_recharge_times":
            router.push({ name: "rechargeBalance" }); //当日充值次数达标
            break;
          case "daily_recharge_amount":
            router.push({ name: "rechargeBalance" }); //当日充值金额达标
            break;
          default:
            router.push({ path: '/'+ getLastTimeGameName() });
        }
      },
      taskReceive(num, id, amount) {
        axios({
          url: "/api/task/receive-reward",
          method: "post",
          params: { serialNum: num, taskId: id }
        })
          .then((res) => {
            if (res.data.code === 2000) {
              Toast.fail(res.data.msg);
            } else {
              this.taskReceivePop(amount);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      taskSignClick(a1, a2){
        const amount = a2 > 0 ? a1 + a2 : a1
        axios.post("/api/task/daily-sign/sign", {})
        .then((response)=> {
              if(response.data.code === 0){
                this.taskReceivePop(amount);
              }else{
                Toast.fail("error!");
              }
        })
        .catch(function (error) {
          console.log(error);
          Toast.fail("Network anomaly!");
        });
      },
      taskReceivePop(amount) {
        state.taskAmount = amount;
        state.startFlag = true;
        state.taskPop = true;
        setTimeout(() => {
          state.startFlag = false;
          state.taskPop = false;
        }, 1500);
      },
      topPopclose(){
        router.go(0);
      },
      // 查看任务弹窗
      dailyGrowthClick(){
        state.startFlag = true;
        state.showBasic = true;
      }
    };
    const showBasicClick = () => {
      state.startFlag = true;
      state.showBasic = true;
    };
    const hideBasicClick = () => {
      state.showBasic = false;
      router.push({ path: '/'+ getLastTimeGameName() });
    };
    return {
      ...toRefs(state),
      ...methods,
      showBasicClick,
      hideBasicClick,
    };
  },
};
</script>

<style scoped>
.nut-popup.popup-top{background:#ffe26f !important}
.popup-top {
  overflow: hidden;
}
.pop-top {
  background: url(../assets/images/bg80.jpg) -10px 40px no-repeat;
  height: 160px;
  background-size: 161px auto;
}
.pop-top h4 {
  padding-left: 130px;
  padding-top: 45px;
  margin-bottom: 0;
  font-size: 18px;
}
.pop-top p {
  padding-left: 160px;
  padding-top: 10;
  margin: 0;
  background: url(../assets/images/fjjb.gif) 125px 10px no-repeat;
  background-size: 30px auto;
}
.pop-top p strong {
  font-size: 36px;
  color: #fb7d26;
  font-weight: 500;
}

.signin-task {
  background: url(../assets/images/bg15.png) 0 0 repeat-y;
  background-size: 100% 100%;
  /*margin-top: 30px;*/
  margin-top: 43px;
}
.signin-task img {
  width: 100%;
  height: auto;
}
.signin-task .bd {
  background: #220d00;
  margin-top: -18px;
  padding: 10px 0 30px 0;
}
.signin-task .dayls {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 98%;
  margin-bottom: 10px;
  margin-left: 1%;
}
.signin-task .dayls .d {
  background: #fffcf6;
  align-items: flex-start;
  text-align: center;
  margin: 2px 0 2px 2px;
  padding-bottom: 3px;
  font-size: 10px;
  width: 23.5%;
  border-radius: 5px;
  overflow: hidden;
  flex-grow: 1;
}
.signin-task .dayls .d:last-child {
  flex-grow: 2;
  width: 48.5%;
  flex-grow: 1;
  background: #fff3b2;
}

.signin-task .dayls .d:last-child p {
  background: url(../assets/images/bg11.png) left 2px no-repeat;
  background-size: 18px 18px;
  padding-left: 20px;
}

.signin-task .dayls .d h5 {
  margin: 0;
  padding: 0;
  line-height: 26px;
  font-weight: 300;
  background:url(../assets/images/bg05c.png) left bottom no-repeat; background-size: 300% auto ;
  color: #fff;
  font-size: 0.8rem;
}
.signin-task .dayls .d p {
  padding-left: 18px;
  line-height: 32px;
  margin: 0;
  color: #bf4019;
  display: inline;
  background: url(../assets/images/fjjb.gif) left 0 no-repeat;
  background-size: 16px 16px;
  font-size: 15px;
}

.signin-task .dayls .d.active {
  background: #d07022;
}
.signin-task .dayls .d.active h5 {
  background:url(../assets/images/bg15_1225b.png) right top no-repeat; background-size: 350% auto;
  color: #fff000;
  font-weight: 600;
}
.signin-task .dayls .d.active p {
  color: #fff;
  font-weight: 600;
}

.signin-task .dayls .complete {
  background: #fcffcd url(../assets/images/bg37.png) right bottom no-repeat;
  background-size: 25px 25px;
  opacity: 1;
}
.signin-task .dayls .complete h5 {
  background:url(../assets/images/bg-ab14.jpg) 0 0 repeat-x; background-size: auto 100% ;
  color: #4e3c00;
}
.signin-task .btn {
  margin: 10px;
}
.ls-h4 {
  margin: 0 0 20px 0;
  line-height: 40px;
  padding: 0 0 0 10px;
  border-left: 5px solid #c8c8c8;
  font-size: 15px;
}

.task-list {
  margin: -20px 10px 10px 10px;
  box-shadow: 0 1px 7px #eee !important;
  background: #fff;
  border-radius: 10px;
}
.task-list .task-item:last-child {
  border-bottom: 0px;
}
.task-list:last-child {
  margin: 0px 10px 10px 10px;
  padding-bottom: 70px;
}
.task-list.pb90 {
  padding-bottom: 90px;
}

.task-flex {
  display: flex;
  justify-content: space-between;
}
.task-flex .l {
  padding-left: 50px;
}
.task-flex .l h5 {
  margin: 5px 0;
  padding: 0;
}
.task-flex .l p {
  margin: 0;
  font-size: 10px;
  color: #666;
}
.task-flex .r {
  text-align: right;
}
.task-flex .r {
  width: 112px;
}
.task-flex .r strong {
  font-size: 18px;
  padding: 5px 0;
  color: #bf4019;
}
.task-item {
  padding: 10px;
  margin-bottom: 5px;
  border-bottom: 1px solid #eee;
}
.task-item .type-1 {
  background: url(../assets/images/bg30.png) 0 5px no-repeat;
  background-size: 40px 40px;
}
.task-item .type-2 {
  background: url(../assets/images/bg31.png) 0 5px no-repeat;
  background-size: 40px 40px;
}
.task-item .type-3 {
  background: url(../assets/images/bg32.png) 0 5px no-repeat;
  background-size: 40px 40px;
}
.task-item .type-4 {
  background: url(../assets/images/bg33.png) 0 5px no-repeat;
  background-size: 40px 40px;
}
.task-item .type-5 {
  background: url(../assets/images/bg34.png) 0 5px no-repeat;
  background-size: 40px 40px;
}
.task-item .type-6 {
  background: url(../assets/images/bg35.png) 0 5px no-repeat;
  background-size: 40px 40px;
}
.task-item .type-7 {
  background: url(../assets/images/bg36.png) 0 5px no-repeat;
  background-size: 40px 40px;
}
.task-item .b {
  margin: 10px 0;
}
.task-item .b2 .nut-indicator {
  margin: 10px 0 0 50px;
}
.task-item .b2 .r {
  text-align: right;
  margin-top: 5px;
}
.nut-countup {
  width: auto;
  color: #940e05 !important;
}

.pop-signin .pop-t {
  height: 110px;
  padding-top: 60px;
  text-align: center;
  color: #503b00;
}
.pop-signin .pop-t h4 {
  margin: 0;
  font-weight: 400;
  line-height: 28px;
  font-size: 20px;
}
.pop-signin .pop-t h4 span{
  font-size: 16px;
  color: #722400;
}
.pop-signin .pop-t p {
  margin: 0;
  padding: 0;
}
.pop-signin .pop-t p strong {
  font-size: 36px;
  color: #940e05;
  font-weight: 500;
  padding-left: 40px;
  background: url(../assets/images/fjjb.gif) 0 5px no-repeat;
  background-size: 35px auto;
}
.pop-signin .pop-b {
  background: #fff;
  height: 70px;
  border-radius: 0 0 12px 12px;
  padding: 20px;
  text-align: center;
}
.pop-signin .pop-b span{ margin-bottom:10px;  color: #ff9e0d ;}
</style>

<style>
.task-item .nut-progress .nut-progress-insidetext {
  background: #994509 !important;
}
.nut-progress-outer {
  margin-top: 4px;
}
.nut-progress .nut-progress-outer {
  background-color: #d2ccb4 !important;
}
.nut-progress .nut-progress-text {
  color: #994509 !important;
  opacity: 0.5;
}
.nut-countup .run-number {
  font-weight: 500 !important;
}
.pop-signin {
  width: 300px;
  padding: 0px;
  background: url(../assets/images/bg18.png) 0 0 no-repeat;
  background-size: 100% auto;
  background-color: transparent !important;
}
.task-item .b2 .nut-indicator .nut-indicator--dot {
  width: 8px;
  height: 8px;
}
.task-item .b2 .nut-indicator .nut-indicator--number {
  background-color: #994509 !important;
  box-shadow: 0 0 1px 1px #994509 !important;
}
.nut-button--small{ height: 28px;line-height: 12px !important;padding: 0 5px; min-width: 100px;}
</style>
